module.exports = __webpack_public_path__ + "img/Ecuador.3c2c2c65.png";